var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80.018,
    viewBox: "0 0 80 80.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M0,40.008A40,40,0,1,1,40,79.96,39.974,39.974,0,0,1,0,40.008Z",
    transform: "translate(0 -0.058)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_50_Kids_Icons-23",
    "data-name": "50_Kids_Icons-23",
    transform: "translate(0 0.058)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M80,39.893A40,40,0,1,1,40-.058,39.975,39.975,0,0,1,80,39.893Z",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4426",
    "data-name": "Group 4426",
    transform: "translate(0 0.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4407",
    "data-name": "Group 4407",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M172.188,143.684H130V107.01a21.081,21.081,0,0,1,21.094-21.068h0a21.081,21.081,0,0,1,21.094,21.068Z",
    transform: "translate(-109.688 -72.539)",
    fill: "#fcf2c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4408",
    "data-name": "Group 4408",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M159.79,246.546c1.025,2.425.467,4.781-1.247,5.264s-3.933-1.092-4.958-3.516-.467-4.781,1.247-5.264S158.765,244.121,159.79,246.546Z",
    transform: "translate(-129.154 -205.038)",
    fill: "#e38a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M326.844,246.545c-1.025,2.425-.467,4.781,1.247,5.264s3.933-1.092,4.958-3.516.467-4.781-1.247-5.264S327.869,244.121,326.844,246.545Z",
    transform: "translate(-275.341 -205.038)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4409",
    "data-name": "Group 4409",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 17.969,
    cy: 16.429,
    rx: 17.969,
    ry: 16.429,
    transform: "translate(23.1 13.469)",
    fill: "#fcf2c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4410",
    "data-name": "Group 4410",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M135.242,412.286l-.008-.131c0-7.991-2.995-15.733-6.652-17.208l-15.575-6.267a20.656,20.656,0,0,0-13.3-.017l-15.8,6.3c-3.66,1.464-6.655,9.2-6.655,17.188l-.008.131Z",
    transform: "translate(-65.172 -327.096)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4411",
    "data-name": "Group 4411",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M233.822,277.037a6.215,6.215,0,0,1-6.219,6.211h-.754a6.215,6.215,0,0,1-6.219-6.211v-16a6.215,6.215,0,0,1,6.219-6.211h.754a6.215,6.215,0,0,1,6.219,6.211Z",
    transform: "translate(-186.157 -215.069)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4413",
    "data-name": "Group 4413",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4412",
    "data-name": "Group 4412",
    transform: "translate(28.125 18.085)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M206.766,140.427a13.375,13.375,0,0,1-13.383,13.367h0A13.375,13.375,0,0,1,180,140.428V129.309a13.375,13.375,0,0,1,13.383-13.367h0a13.375,13.375,0,0,1,13.384,13.367v11.118Z",
    transform: "translate(-179.999 -115.942)",
    fill: "#f5b68c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4414",
    "data-name": "Group 4414",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    cx: 1.548,
    cy: 1.546,
    rx: 1.548,
    ry: 1.546,
    transform: "translate(34.39 41.441)",
    fill: "#572020"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 1.548,
    cy: 1.546,
    rx: 1.548,
    ry: 1.546,
    transform: "translate(44.653 41.441)",
    fill: "#572020"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4416",
    "data-name": "Group 4416",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4415",
    "data-name": "Group 4415",
    transform: "translate(25.358 15.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M178,102.134c-8.677,0-15.711,7.614-15.711,17.008a18.01,18.01,0,0,0,2.13,8.556l1.561-13.222h24.037l1.564,13.223a18.012,18.012,0,0,0,2.13-8.555C193.716,109.748,186.682,102.134,178,102.134Z",
    transform: "translate(-162.294 -102.134)",
    fill: "#fcf2c8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4417",
    "data-name": "Group 4417",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M251.273,279.6a2.384,2.384,0,0,1-4.653.538,2.519,2.519,0,0,0-.114.709,2.553,2.553,0,0,0,5.105,0A2.511,2.511,0,0,0,251.273,279.6Z",
    transform: "translate(-207.989 -235.974)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4418",
    "data-name": "Group 4418",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M135.233,425.1c0-7.991-2.995-15.733-6.652-17.208L116.2,402.906a10.942,10.942,0,0,1-19.889.053l-12.4,4.95c-3.66,1.464-6.655,9.2-6.655,17.188l-.008.131h58Z",
    transform: "translate(-65.172 -340.038)",
    fill: "#966796"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4419",
    "data-name": "Group 4419",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M185.661,120.606l-1.17-3.97L168,128.628v8.126l10.3-2.548C184.153,132.759,187.448,126.67,185.661,120.606Z",
    transform: "translate(-141.75 -98.443)",
    fill: "#fcf2c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4420",
    "data-name": "Group 4420",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M292.088,157.843a31.945,31.945,0,0,0-2.7-11.495,7.023,7.023,0,1,0,2.7,11.495Z",
    transform: "translate(-236.25 -123.176)",
    fill: "#fcf2c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4422",
    "data-name": "Group 4422",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4421",
    "data-name": "Group 4421",
    transform: "translate(27.44 37.431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M196.3,239.91a5.941,5.941,0,0,0-5.869,5.07h-3a5.933,5.933,0,1,0,0,1.726h3a5.936,5.936,0,1,0,5.869-6.8Zm-14.742,10.14a4.207,4.207,0,1,1,4.212-4.207A4.215,4.215,0,0,1,181.557,250.05Zm14.742,0a4.207,4.207,0,1,1,4.212-4.207A4.215,4.215,0,0,1,196.3,250.05Z",
    transform: "translate(-175.617 -239.91)",
    fill: "#2961a5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4423",
    "data-name": "Group 4423",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M234.749,316.309a4.888,4.888,0,0,1-6.487,0c-1.231-1.158-3.091.693-1.856,1.854a7.567,7.567,0,0,0,10.2,0c1.235-1.161-.625-3.012-1.856-1.854Z",
    transform: "translate(-190.687 -266.646)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4425",
    "data-name": "Group 4425",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4424",
    "data-name": "Group 4424",
    transform: "translate(40 16.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M264.276,108.377c-.556-2.391-2.207-3.153-3.668-1.693l-3.865,3.86c-1.461,1.46-.7,3.108,1.7,3.663l3.252.755c2.393.555,3.9-.947,3.341-3.337Z",
    transform: "translate(-256 -105.942)",
    fill: "#966796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M314.168,158.271c2.394.555,3.157,2.2,1.7,3.664L312,165.8c-1.461,1.46-3.112.7-3.668-1.693l-.755-3.248c-.556-2.391.947-3.893,3.341-3.337Z",
    transform: "translate(-299.418 -149.371)",
    fill: "#966796"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M298.975,148.913a2.561,2.561,0,1,1,0-3.619A2.564,2.564,0,0,1,298.975,148.913Z",
    transform: "translate(-248.57 -121.996)",
    fill: "#b08db0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar2);
export default __webpack_public_path__ + "static/media/avatar2.cdb43169865d129586d6fe69867e6a00.svg";
export { ForwardRef as ReactComponent };